import { render, staticRenderFns } from "./GoodsInfoCellSpecs.vue?vue&type=template&id=78fd0f76&scoped=true"
import script from "./GoodsInfoCellSpecs.vue?vue&type=script&lang=js"
export * from "./GoodsInfoCellSpecs.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoCellSpecs.vue?vue&type=style&index=0&id=78fd0f76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd0f76",
  null
  
)

export default component.exports